import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray"
import emitter from "tiny-emitter/instance"

const storage = localStorage

export enum DSyncChecklistType {
  CK_SETUP_DOCUMENTATION = "ck_setup_documentation",
  CK_ADMIN_ACCESS = "ck_admin_access",
  CK_ACTIVATION_EMAILS = "ck_activation_emails",
  CK_PEOPLE_DATA = "ck_people_data",
  CK_PROVIDERS = "ck_providers",
  CK_REGIONS = "ck_regions"
}

export enum SSOChecklistType {
  CK_ADMIN_ACCESS = "ck_admin_access",
  CK_SETUP_DOCUMENTATION = "ck_setup_documentation",
  CK_PEOPLE_DATA = "ck_people_data",
  CK_PROVIDERS = "ck_providers",
  CK_REGIONS = "ck_regions"
}

export const EVENT_DSYNC = "DSYNC_CHECKLIST_STORED"
export const EVENT_SSO = "SSO_CHECKLIST_STORED"

const LOCAL_STORAGE_DSYNC_KEY = "checklistDsync"
const LOCAL_STORAGE_SSO_KEY = "checklistSSO"

class ChecklistService {
  getDsyncChecklist(): DSyncChecklistType[] {
    try {
      return JSON.parse(storage.getItem(LOCAL_STORAGE_DSYNC_KEY) || "[]")
    } catch (e) {
      return []
    }
  }

  getSSOChecklist(): SSOChecklistType[] {
    try {
      return JSON.parse(storage.getItem(LOCAL_STORAGE_SSO_KEY) || "[]")
    } catch (e) {
      return []
    }
  }

  setDSyncChecklist(value: DSyncChecklistType) {
    try {
      const currentStorage = this.getDsyncChecklist()
      const arr = addOrRemoveFromArray(currentStorage, value)
      const str = JSON.stringify(arr)

      storage.setItem(LOCAL_STORAGE_DSYNC_KEY, str)
      emitter.emit(EVENT_DSYNC, arr)
    } catch (e) {
      console.log(e)
    }
  }

  setSSOChecklist(value: SSOChecklistType) {
    try {
      const currentStorage = this.getSSOChecklist()
      const arr = addOrRemoveFromArray(currentStorage, value)
      const str = JSON.stringify(arr)

      storage.setItem(LOCAL_STORAGE_SSO_KEY, str)
      emitter.emit(EVENT_SSO, arr)
    } catch (e) {
      console.log(e)
    }
  }

  addEventListener(EVENT_KEY: string, cb: () => void) {
    emitter.on(EVENT_KEY, cb)
  }

  removeEventListener(EVENT_KEY: string, cb: () => void) {
    emitter.off(EVENT_KEY, cb)
  }
}
const checklistService = new ChecklistService()
export default checklistService
